import { ReactNode, forwardRef } from 'react';

import {
  Theme,
  Typography,
  TypographyProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(1),
    },
  });

export interface SubtitleProps
  extends Omit<TypographyProps, 'classes'>,
    WithStyles<typeof styles> {
  children: ReactNode;
}

export const Subtitle = forwardRef<HTMLDivElement, SubtitleProps>(
  ({ children, className, classes, ...rest }, ref) => {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        component="div"
        ref={ref}
        className={classNames(classes.root, className)}
        {...rest}
      >
        {children}
      </Typography>
    );
  },
);

Subtitle.displayName = 'DialogComposite.Subtitle';

export default withStyles(styles)(Subtitle);
